import { AxiosInstance } from 'axios';

export interface PostLikeResponse {
  success: boolean;
  data: {
    liked: boolean;
    message?: string;
  };
  message?: string;
}

export default class PostLikeService {
  constructor(private axios: AxiosInstance) {}

  // 좋아요 토글 (Auth Required)
  toggleLike = async (postId: string): Promise<PostLikeResponse> => {
    const { REACT_APP_API_ENDPOINT } = process.env;
    this.axios.defaults.baseURL = REACT_APP_API_ENDPOINT;
    const { data } = await this.axios.post(`/post-like/${postId}/toggle`);
    return data;
  };

  // 좋아요 상태 확인 (Auth Required)
  getLikeStatus = async (postId: string): Promise<PostLikeResponse> => {
    const { REACT_APP_API_ENDPOINT } = process.env;
    this.axios.defaults.baseURL = REACT_APP_API_ENDPOINT;
    const { data } = await this.axios.get(`/post-like/${postId}/status`);
    return data;
  };
}






